import store from '../store';
import { deleteUser } from '../slices/authSlice';

// Función para eliminar un usuario específico por email
export const deleteUserByEmail = async (email) => {
  try {
    // Disparar la acción deleteUser del slice de autenticación
    const result = await store.dispatch(deleteUser(email));
    
    // Verificar si la acción fue exitosa
    if (result.meta.requestStatus === 'fulfilled') {
      console.log(`Usuario ${email} eliminado correctamente`);
      return { success: true, message: `Usuario ${email} eliminado correctamente` };
    } else {
      console.error(`Error al eliminar usuario ${email}:`, result.payload);
      return { 
        success: false, 
        message: result.payload?.message || `Error al eliminar usuario ${email}` 
      };
    }
  } catch (error) {
    console.error(`Error inesperado al eliminar usuario ${email}:`, error);
    return { 
      success: false, 
      message: error.message || `Error inesperado al eliminar usuario ${email}` 
    };
  }
};

// Función para ejecutar directamente desde la consola
export const executeDeleteUser = (email) => {
  console.log(`Ejecutando eliminación del usuario: ${email}`);
  deleteUserByEmail(email)
    .then(result => {
      console.log('Resultado:', result);
      if (result.success) {
        console.log('✅ Usuario eliminado correctamente');
      } else {
        console.error('❌ Error al eliminar usuario:', result.message);
      }
    })
    .catch(error => {
      console.error('❌ Error crítico:', error);
    });
};

// Para facilitar el acceso desde la consola del navegador
window.adminUtils = {
  deleteUser: executeDeleteUser,
  // Función específica para eliminar el usuario solicitado
  deleteSpecificUser: () => executeDeleteUser('abalarezoc@hotmail.com')
};
